export const WorkplaceConfigVI = {
  "WorkplaceAdd": {
    "WorkplaceAdd": "Thêm nơi làm việc",
    "WorkplaceEdit": "Sửa nơi làm việc",
    "WorkplaceDelete": "Xoá nơi làm việc",
    "ListWorkplace": "Danh sách nơi làm việc",
    "Workplace" : "Danh sách nơi làm việc"
  },
  "WorkplaceTitle": {
    "name" : "Tên nơi làm việc",
    "WorkLocation" : "Địa chỉ làm việc" ,
    "CurrentDepartment" : "Phòng ban ",
    "status" : "Trạng thái",
    "active" : "Hoạt động",
    "inactive" : "Không hoạt động"
  },
  "placeholderWorkplace": {
    "name" : "Tên nơi làm việc",
    "WorkLocation" : "Địa chỉ làm việc" ,
    "CurrentDepartment" : "Phòng ban "
  },
  "button": {
    "buttonSubmit": "Tạo mới",
    "buttonUpdate": "Sửa",
    "buttonCancel": "Hủy Bỏ"
  },
  "NotificationWorkplace": {
    "edit": "Sửa dữ liệu thành công...",
    "add": "Thêm dữ liệu thành công...",
    "delete": "Xóa dữ liệu thành công...",
    "Liquidation": "Cập nhật trạng thái thành công...",
    "question": " Bạn có muốn xóa không ? ",
    "title" : "sửa hình thức làm việc",
    "required": " là yêu cầu!"
  }
}